import React from 'react';

import { SelectAsyncInputProps } from 'src/shared/components/form-elements/select-input';
import { getCategories } from 'src/near-me-check/api/get-categories';
import { Translation, translations } from 'src/shared/translation';
import { useAppConfig } from 'src/shared/contexts/app-config';
import { FormSelectAsync } from 'src/shared/components/form-elements/form-select-async';
import { WithOptional } from 'src/types/optional-types';

const MIN_INPUT_LENGTH = 1;
const transl = translations.nearmecheck.start_page.form;

type CategorySelectProps = WithOptional<
    Omit<
        SelectAsyncInputProps<{ value: string; label: string }>,
        'loadingCode' | 'noOptionsCode' | 'loadOptions' | 'noOptionsMessage' | 'cacheOptions'
    >,
    'label' | 'placeholderCode'
> & {
    defaultValue?: {
        label: string;
        value: number;
    };
    isLoading?: boolean;
};

export function CategorySelect(props: CategorySelectProps) {
    const label = props.label || <Translation code={transl.category.label} />;
    const placeholderCode = props.placeholderCode || transl.category.placeholder;
    const { language, publicKey } = useAppConfig();

    async function loadCategoryOptions(queryString: string) {
        if (!queryString || queryString.length < MIN_INPUT_LENGTH) {
            return;
        }

        const categories = (await getCategories(queryString, language, publicKey)) as {
            id: string;
            fullName: string;
        }[];

        return categories.map((category) => ({ value: category.id, label: category.fullName }));
    }

    return (
        <FormSelectAsync
            label={label}
            placeholderCode={placeholderCode}
            loadingCode={transl.select_input.options_loading}
            noOptionsCode={transl.select_input.no_options}
            noOptionsMessage={({ inputValue }: { inputValue: string }) =>
                (
                    <Translation
                        code={
                            inputValue.length < MIN_INPUT_LENGTH
                                ? transl.select_input.no_input
                                : transl.select_input.no_options
                        }
                    />
                ) as any as string
            }
            noDropdownIndicator
            cacheOptions
            loadOptions={loadCategoryOptions}
            {...props}
        />
    );
}
